import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "pagination-container" }

import { ref, onMounted, getCurrentInstance, reactive } from 'vue'
import { getUserMoneyListApi } from '@/apis/user'
import { joinParams } from "@/utils/index";
import Keys from "@/constant/key";
interface BalanceItem {
  user_id: string
  operator: string
  old_amount: number
  operation_amount: number
  new_amount: number
  reason: string
  remark: string
  operation_time: string
}

// 定义分页类型
interface Pagination {
  page: number
  pageSize: number
}

// 数据

export default /*@__PURE__*/_defineComponent({
  __name: 'Balance',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

// 用户余额
const balanceList = ref<BalanceItem[]>([])
const loading = ref(false)
const total = ref(0)
const pagination = reactive<Pagination>({
  page: 1,
  pageSize: 10
})

// 搜索表单
const searchForm = reactive({
  mobile_phone: '',
  user_ids: '',
  time_range: [] as [string, string] | []
})

// 获取余额列表
const getBalanceList = async () => {
  loading.value = true
  // 构建请求参数
  const params: any = {
    page: pagination.page,
    page_size: pagination.pageSize,
    mobile_phone: searchForm.mobile_phone,
    user_ids: searchForm.user_ids
  }
  
  // 处理时间范围
  if (searchForm.time_range && searchForm.time_range.length === 2) {
    params.start_date = searchForm.time_range[0]
    params.end_date = searchForm.time_range[1]
  }
  
  const { code, data, msg } = await getUserMoneyListApi(params)
  loading.value = false
  if (code == 200) {
    balanceList.value = data?.data || []
    total.value = data?.total || 0
  } else {
    proxy.$message({ type: 'error', message: msg || '获取余额列表失败' })
  }
}

// 搜索
const handleSearch = () => {
  pagination.page = 1
  getBalanceList()
}

// 导出数据
const handleExport = async () => {
    window.open(
        `${Keys.baseUrl}/admin/user/get_user_money_list?${joinParams({
        ...searchForm,
        is_export: 1,
        })}`
    );
}

// 分页大小变化
const handleSizeChange = (size: number) => {
  pagination.pageSize = size
  getBalanceList()
}

// 当前页码变化
const handleCurrentChange = (current: number) => {
  pagination.page = current
  getBalanceList()
}

// 初始化
onMounted(() => {
  getBalanceList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: searchForm.mobile_phone,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.mobile_phone) = $event)),
        placeholder: "请输入用户手机号"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: searchForm.user_ids,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.user_ids) = $event)),
        placeholder: "请输入用户ID"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: searchForm.time_range,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.time_range) = $event)),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSearch,
        class: "filter-item"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleExport,
        class: "filter-item"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: balanceList.value,
      border: "",
      style: {"width":"100%"},
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "user_id",
          label: "用户id",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "admin_name",
          label: "操作人",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "original_money",
          label: "原金额",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sum",
          label: "操作金额",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "now_money",
          label: "操作后金额",
          width: "120",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remark",
          label: "原因",
          "min-width": "200",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "备注",
          "min-width": "200",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "操作时间",
          width: "180",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.created_at || '0000-00-00 00:00:00'), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (total.value > 0)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            "current-page": pagination.page,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((pagination.page) = $event)),
            "page-size": pagination.pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((pagination.pageSize) = $event)),
            "page-sizes": [10, 20, 50, 100],
            layout: "total, sizes, prev, pager, next, jumper",
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})